
export const COL_COMPLIANCE_CARDS = 'compliance_cards';
export const COL_JOB_LOGS = 'system_job_runs';
export const COL_APPROVAL_REQUESTS = 'approval_requests';
export const COL_APPROVAL_FLOWS = 'approvalFlows';
